import { useEffect, useRef, useState } from "react";

// Marquee-scrolls its text only when it can't fit on one line — one
// continuous leftward loop (text duplicated so the wrap is seamless).
// The scroll runs ONLY while this caption's media is playing (moving
// prop); stopped captions render start-aligned + clipped, no motion.
export function ScrollText({ text, moving, className }) {
    const boxRef = useRef(null);
    const textRef = useRef(null);
    const [copyW, setCopyW] = useState(null); // null = fits (static)

    useEffect(() => {
        const box = boxRef.current;
        const txt = textRef.current;
        if (!box || !txt) return;
        const check = () => {
            const w = txt.scrollWidth;
            setCopyW(w > box.clientWidth + 1 ? w : null);
        };
        check();
        document.fonts?.ready?.then(check).catch(() => {});
    }, [text]);

    const ticker = copyW != null && moving;
    return (
        <div
            ref={boxRef}
            className={`overflow-hidden whitespace-nowrap ${className}`}
        >
            {copyW == null ? (
                <span ref={textRef} className="inline-block">
                    {text}
                </span>
            ) : ticker ? (
                <span
                    className="inline-block animate-caption-scroll"
                    style={{
                        animationDuration: `${Math.max((copyW + 24) / 22, 6)}s`,
                    }}
                >
                    <span className="inline-block pr-6">{text}</span>
                    <span aria-hidden className="inline-block pr-6">
                        {text}
                    </span>
                </span>
            ) : (
                <span className="inline-block">{text}</span>
            )}
        </div>
    );
}